import { newSize, newVector, Size } from '@lessonup/pins-shared';
import React from 'react';
import { DEFAULT_STAR_INNER_RADIUS, DEFAULT_STAR_POINTS } from '../shapePinComponent.utils';

export interface StarShapeProps {
  size: Size;
  strokeWidth: number;
  points?: number;
  /** Radius of the inner points of the star as a percentage of the outer radius points */
  innerRadius?: number;
}

export const StarShape: React.FC<StarShapeProps> = ({
  size,
  strokeWidth,
  points = DEFAULT_STAR_POINTS,
  innerRadius = DEFAULT_STAR_INNER_RADIUS,
}) => {
  const correctedSize = newSize(size.width - strokeWidth, size.height - strokeWidth);
  const center = newVector(size.width / 2, size.height / 2);
  const startAngle = -Math.PI / 2; // This equals -90 degrees which points straight up in SVG coordinates
  const innerRadiusFraction = innerRadius / 100;

  // Since the shape can be stretched, we need to use separate radii for the x and y axes
  const innerRadii = newVector(
    (correctedSize.width / 2) * innerRadiusFraction,
    (correctedSize.height / 2) * innerRadiusFraction
  );
  const outerRadii = newVector(correctedSize.width / 2, correctedSize.height / 2);

  const pointsArray = Array.from({ length: points * 2 }, (_, i) => {
    const angle = startAngle + (i * Math.PI) / points;
    const isOuter = i % 2 === 0;
    // Pick radius based on inner or outer point
    const rx = isOuter ? outerRadii.x : innerRadii.x;
    const ry = isOuter ? outerRadii.y : innerRadii.y;
    // Calculate the point position based on the angle and radius
    const x = center.x + rx * Math.cos(angle);
    const y = center.y + ry * Math.sin(angle);

    return `${x},${y}`;
  });

  return <polygon points={pointsArray.join(' ')} />;
};
